// import React from 'react';
import { Link, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
// import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { useFormulirList } from '../../components/hooks/useFormulir';

const isPdf = (url) => /\.pdf(\?.*)?$/i.test(url);
const isImage = (url) => /\.(jpe?g|png|webp|gif)(\?.*)?$/i.test(url);

const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
);

// Tiap viewer punya plugin instance sendiri (sebelumnya di Katekisasi dipakai bersama)
const PdfViewer = ({ url }) => (
    <div className="w-full h-[75vh] rounded-xl shadow-lg overflow-hidden border border-blue-600 bg-white">
        <iframe
            src={url}
            title="Pratinjau formulir"
            className="w-full h-full"
        />
    </div>
);

const FileBlock = ({ file }) => (
    <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200">
        <div className="text-center mb-6">
            <h2 className="text-2xl font-bold tracking-tight text-blue-900 uppercase">{file.title}</h2>
            <a
                href={file.url}
                download
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-all duration-300 hover:scale-105 mt-4"
            >
                <DownloadIcon /> DOWNLOAD
            </a>
        </div>
        {isPdf(file.url) && <PdfViewer url={file.url} />}
        {isImage(file.url) && <img src={file.url} alt={file.title} className="w-full h-auto rounded-xl shadow" />}
    </div >
);

const FormulirPage = () => {
    const { slug } = useParams();
    const { list, loading, error } = useFormulirList();

    if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-600">Memuat...</div>;
    if (error) return <div className="min-h-screen flex items-center justify-center text-red-600">Gagal memuat formulir.</div>;

    const formulir = list.find((f) => f.slug === slug || String(f.id) === slug);
    if (!formulir) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center gap-4">
                <p className="text-gray-700">Formulir tidak ditemukan.</p>
                <Link to="/formulir" className="text-blue-600 underline">Kembali ke daftar formulir</Link>
            </div>
        );
    }

    const multi = formulir.files.length > 1;

    return (
        <div className="bg-white text-gray-800 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
            <div className={`${multi ? 'max-w-7xl' : 'max-w-5xl'} mx-auto rounded-xl shadow-2xl overflow-hidden p-8 lg:p-12 bg-gray-100`}>
                {formulir.image && (
                    <img src={formulir.image} alt={formulir.title} className="w-full h-auto rounded-xl shadow-lg mb-10" />
                )}

                <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-10 text-center text-blue-900 uppercase">
                    {formulir.title}
                </h1>

                {formulir.content && (
                    <div
                        className="prose prose-lg max-w-none mx-auto mb-12"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formulir.content) }}
                    />
                )}

                <div className={`grid gap-8 ${multi ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'}`}>
                    {formulir.files.map((file, i) => (
                        <FileBlock key={i} file={file} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FormulirPage;